export const SIGNALR_CONST = Object.freeze({
	invokeAcknowledgeReceiptAsync: "AcknowledgeReceiptAsync",
	invokeSubscribeToGroupAsync: "SubscribeToGroupAsync",
	invokeUnsubscribeFromGroupAsync: "UnsusbscribeFromGroupAsync",
});
